import RU from './ru-RU';
import EN from './en-EN';
import { IDictionary } from './interfaces/IDictionary';
import { lang } from './interfaces/lang';

export type langKeys = keyof typeof RU;

export default class Dictionary {
    static RU = RU;
    static EN = EN;
    lang: lang;
    dictionary: IDictionary;

    constructor(rawLang: lang) {
        const lang = rawLang.trim().toLowerCase();
        switch (lang) {
            case 'ru':
                this.lang = 'ru';
                this.dictionary = Dictionary.RU;
                break;
            case 'en':
                this.lang = 'en';
                this.dictionary = Dictionary.EN;
                break;
            default:
                throw new Error('language is not exist');
        }
    }

    checkWord(word: string) {
        return this.dictionary.hasOwnProperty(word);
    }
    getWord(word: string): string {
        if (this.checkWord(word))
            return this.dictionary[word as keyof IDictionary];
        else return word;
    }
    getKey(word: string) {
        for (let i in this.dictionary) {
            if (this.dictionary[i as keyof IDictionary] === word) return i;
        }
    }
}
